module.exports = __webpack_public_path__ + "img/kayaking_white.a8bdf2f1.svg";